import type { HTMLAttributes, ReactNode } from 'react';

export interface ModalData {
  open?: boolean;
  position?: [number, number]; // [x, y], position to open and close the modal from, default to center of the screen
  onCloseClick?: () => void;
  shrinkHeight?: boolean;
}

export interface ModalProps extends HTMLAttributes<HTMLDivElement>, ModalData {
  children?: ReactNode;
}
